import { Box, Input, Stack } from '@mui/material';
import React, { useState } from 'react';
import useBundleTranslation from 'i18n';
import { homePage } from 'api/home-page';
import { useHomeContext } from 'app/home/context';
import LoadingPlaceholder from 'components/common/loading-placeholder/LoadingPlaceholder';
import { Popup } from 'components/common/popup/Popup';
import parse from 'html-react-parser';

export default function AddFolderPopup({
    onHide,
    parentFolderId = 0,
    parentFolderName = '',
}: {
    onHide: () => void;
    parentFolderId?: number;
    parentFolderName?: string;
}) {
    const { t } = useBundleTranslation('app/home');
    const ctx = useHomeContext();

    const [refetchData] = [ctx.refetchData];
    const [showLoading, setShowLoading] = useState(false);
    const [folderName, setFolderName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const dataTestAttr = 'add_folder_popup';

    const onAddFolder = async () => {
        if ('' == folderName) {
            setErrorMessage(t('folder_name_is_required'));
            return;
        }

        setShowLoading(true);
        const data = await homePage.createFolder(folderName, parentFolderId);

        setShowLoading(false);
        if ('OK' == data.status) {
            onHide();
            refetchData();
        } else {
            setErrorMessage(t('folder_name_is_not_allowed'));
        }
    };

    return showLoading ? (
        <LoadingPlaceholder />
    ) : (
        <Popup
            settings={{
                title: parentFolderId > 0 ? t('add_subfolder') : t('add_folder'),
                textOK: parentFolderId > 0 ? t('add_subfolder') : t('add_folder'),
            }}
            maxWidth="popupSm"
            open={true}
            onHide={onHide}
            onConfirm={onAddFolder}
        >
            <Stack spacing={1}>
                {parentFolderName && parentFolderId && parentFolderId > 0 && (
                    <Box>{parse(t('add_subfolder_title', { parentFolderName }))}</Box>
                )}

                <Box>
                    <Input
                        value={folderName}
                        sx={{ width: '100%' }}
                        name={'name'}
                        placeholder={t('folder_name')}
                        onChange={(e) => setFolderName(e.target.value)}
                        inputProps={{ 'data-1p-ignore': true }}
                    />
                </Box>

                {errorMessage && <Box sx={{ color: 'error.main', pt: 0.25 }}>{errorMessage}</Box>}
            </Stack>
        </Popup>
    );
}
